import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_DISCOUNT_ONLY from "./default";
import { Logger } from "../../dependencies/logger";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logger = new Logger("RESTAURANT_STORE - DISCOUNT_ONLY", "LOG");
// logger.enable();
const logEffect = (property: keyof FilterActionTypes<DiscountOnlyModel>) =>
  createLogEffect<DiscountOnlyModel>("DISCOUNT_ONLY", property, false);

export type DiscountOnlyModel = {
  value: boolean | null;
  valueOnChange: LogEffect<DiscountOnlyModel>;
  set: Action<DiscountOnlyModel, boolean>;
};

const discountOnlyModel: DiscountOnlyModel = {
  value: DEFAULT_DISCOUNT_ONLY,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    logger.log("set", payload);
    state.value = payload;
  }),
};

export default discountOnlyModel;
